import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Button} from 'react-bootstrap'
import extract from '../../core/extract'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import StaticMap from '../../core/components/StaticMap'
import config from '../../config'
import i18n from '../i18n'
import style from './TicketAddressCard.less'
import TicketCorrectLocationReference from './TicketCorrectLocationReference'
import {linkFinder} from '../../core/links'
import uuid from 'node-uuid'
import {apiOption, apiResponse, apiUrl} from '../../core/fetchz'
import {errorStatus} from '../../core/redux/status'

class TicketAddressCard extends Component {
    static propTypes = {
        ticketIdLock: PropTypes.string,
        split: PropTypes.bool
    }

    state = {}

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    _openModalLocationReference = () => {
        this.setState({correctLocationReference: true})
    }

    _closeModalLocationReference = () => {
        this.setState({correctLocationReference: undefined})
    }

    _correctLocationReference = (v) => {
            const {dispatch, ticket} = this.props
            const {uid} = ticket
            const options = {
                method: 'PATCH',
                body: {
                    processUid: uuid.v4(),
                    ...v,
                    commandType: 'CorrectLocationReference'
                }
            }

            fetch(apiUrl(`${config.api.event.url}/tickets/${uid}`), apiOption(options))
                .then(apiResponse)
                .then(() => {
                    this._closeModalLocationReference()
                    window.location.reload()
                })
                .catch((e) => {
                    dispatch(errorStatus(e.message))
                })

    }

    render() {
        const {dispatch, ticket, patrimony, ticketIdLock, split, ...others} = this.props

        const cardHeader = (title) => (
            <div>
                <h5>{title}</h5>
                {((ticket || {})._links || []).find(linkFinder('CorrectLocationReference')) &&
                <Button
                    bsStyle='link'
                    onClick={this._openModalLocationReference}
                    title={i18n.correctLocationReference}
                    alt={i18n.correctLocationReference}
                >
                    <Icon icon='pencil' size='xs' />
                </Button>}
            </div>

        )

        const isLocked = () => {
            if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true
            return !ticket
        }

        return (
            <div className={style.default}>
                <Card
                    header={cardHeader(i18n.interventionLocation)}
                    {...others}>
                    {!isLocked() && (
                        <Row>
                            <TicketCorrectLocationReference
                                ticket={ticket}
                                show={this.state.correctLocationReference}
                                onHide={this._closeModalLocationReference}
                                onSubmit={this._correctLocationReference}
                            />
                            <Col sm={split && 6 || 12}>
                                {ticket.linkedEntities.patrimony && (
                                    <a
                                        href=''
                                        onClick={(e) => this._navigate(e, '/patrimonies/' + ticket.linkedEntities.patrimony.uid)}>
                                        <h5>
                                            <Icon icon='plus' size='xs' />
                                            <span>{ticket.linkedEntities.patrimony.name}</span>
                                        </h5>
                                    </a>
                                )}
                                <div className={style.address}>
                                    <p>{ticket.address.quality}</p>
                                    <p>{ticket.address.number} {ticket.address.street}</p>
                                    <p>{ticket.address.zipCode} {ticket.address.city}</p>
                                    <ul>
                                        {ticket.address.recipientSupplement && Object.keys(ticket.address.recipientSupplement).map((k, index) => (
                                            <li key={index}>
                                                <span>{extract(i18n.recipientSupplementEnum, k)} </span>
                                                <span>{ticket.address.recipientSupplement[k]}</span>
                                            </li>
                                        ))}
                                        {ticket.address.geographicalSupplement && Object.keys(ticket.address.geographicalSupplement).map((k, index) => (
                                            <li key={index}>
                                                <span>{extract(i18n.geographicalSupplementEnum, k)} </span>
                                                <span>{ticket.address.geographicalSupplement[k]}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <p>{ticket.address.complement}</p>
                                </div>
                            </Col>
                            <Col sm={split && 6 || 12}>
                                {ticket.linkedEntities.patrimony && ticket.linkedEntities.patrimony.uid == (patrimony && patrimony.uid) && (
                                    <StaticMap info
                                        apiKey={config.google.apiKey}
                                        ratio={16/9}
                                        identify={(a) => a.geoLocation}
                                        value={[...patrimony.addresses, ...patrimony.complementaryAddresses]} />
                                )}
                            </Col>
                        </Row>
                    )}
                    {isLocked() && (
                        <div className={style.noTicketInfo}>
                            <span>{i18n.noTicketInfo}</span>
                        </div>
                    )}
                </Card>
            </div>
        )
    }
}

TicketAddressCard = connect((state) => ({
    ticket: state.ticket.ticket,
    patrimony: state.patrimony.patrimony
}))(TicketAddressCard)

export default TicketAddressCard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketAddressCard.js